<template>
  <section>
    <h2>Cascader 级联选择器</h2>
    <p class="desc">从一组相关联的数据集合中进行选择，常用于省市区、公司级层、事务分类等。</p>
    <h2>基础用法</h2>
    <div class="container">
      <div class="example">
        <y-cascader :data="source" v-model="selected" @on-change="onChange"></y-cascader>
      </div>
      <div class="code-wrapper" v-highlight>
        <pre class="code"><code class="html" v-text="text1"></code></pre>
      </div>
    </div>
    <h2>Attributes</h2>
    <div class="attr">
      <table>
        <thead>
          <tr>
            <th>参数</th>
            <th>说明</th>
            <th>类型</th>
            <th>可选值</th>
            <th>默认值</th>
          </tr>
        </thead>
        <tbody>
          <tr>
            <td>data</td>
            <td>数据源，格式参照示例</td>
            <td>Array</td>
            <td>--</td>
            <td>--</td>
          </tr>
          <tr>
            <td>value</td>
            <td>已选项的数据，支持v-model,格式参照示例</td>
            <td>Array</td>
            <td>--</td>
            <td>--</td>
          </tr>
        </tbody>
      </table>
    </div>
    <h2>Cascader events</h2>
    <div class="attr">
      <table>
        <thead>
          <tr>
            <th>事件名</th>
            <th>说明</th>
            <th>返回值</th>
          </tr>
        </thead>
        <tbody>
          <tr>
            <td>on-change</td>
            <td>选择完成后的回调，返回值 value 即已选值 value，selectedData 为已选项的具体数据</td>
            <td>value, selectedData</td>
          </tr>
          <tr>
            <td>on-visible-change</td>
            <td>展开和关闭弹窗时触发</td>
            <td>显示状态</td>
          </tr>
        </tbody>
      </table>
    </div>
  </section>
</template>
<script>
export default {
  data () {
    return {
      text1: `<y-cascader :data="source" v-model="selected" @on-change="onChange"></y-cascader>
selected: ['beijing', 'gugong'],
source: [
        {
          value: 'beijing',
          label: '北京',
          children: [
            {
              value: 'gugong',
              label: '故宫',
            },
            {
              value: 'tiantan',
              label: '天坛',
            },
            {
              value: 'wangfujing',
              label: '王府井',
            },
          ],
        }, {
          value: 'jiangsu',
          label: '江苏',
          children: [
            {
              value: 'nanjing',
              label: '南京',
              children: [
                {
                  value: 'fuzimiao',
                  label: '夫子庙',
                },
              ],
            },
            {
              value: 'suzhou',
              label: '苏州',
              children: [
                {
                  value: 'zhuozhengyuan',
                  label: '拙政园',
                },
                {
                  value: 'shizilin',
                  label: '狮子林',
                },
              ],
            },
          ],
        },
      ],`,
      selected: ['beijing', 'gugong'],
      source: [
        {
          value: 'beijing',
          label: '北京',
          children: [
            {
              value: 'gugong',
              label: '故宫',
            },
            {
              value: 'tiantan',
              label: '天坛',
            },
            {
              value: 'wangfujing',
              label: '王府井',
            },
          ],
        }, {
          value: 'jiangsu',
          label: '江苏',
          children: [
            {
              value: 'nanjing',
              label: '南京',
              children: [
                {
                  value: 'fuzimiao',
                  label: '夫子庙',
                },
              ],
            },
            {
              value: 'suzhou',
              label: '苏州',
              children: [
                {
                  value: 'zhuozhengyuan',
                  label: '拙政园',
                },
                {
                  value: 'shizilin',
                  label: '狮子林',
                },
              ],
            },
          ],
        },
      ],
    }
  },
  methods: {
    onChange (val1, val2) {
      console.log('val1', val1)
      console.log('val2', val2)
    },
  },
}
</script>
